import { Product } from '@/api';
import moment from 'moment';

export interface InboxNotificationAPI {
	id: string;
	type: string;
	data: string;
	created_at: string;
	ordwaySubscriptionState?: Record<string, any>;
}

export class InboxNotification {
	public id: string;
	public type: string;
	public parameters: Record<string, any>;
	public reason: string;
	public createdAt: string;
	public ordwaySubscriptionState?: Record<string, any>;
	public retryEndpointUrl?: string;
	public retryEndpointMethod?: 'POST' | 'PATCH';
	public product: Product | null;

	get ordwaySubscriptionParameters(): Record<string, any> {
		if (this.ordwaySubscriptionState) {
			const { levno_product_id, plans, status } = this.ordwaySubscriptionState;
			return {
				'Product Id': levno_product_id,
				'Plan Name': plans ? plans[0].plan_name : '',
				'Plan Id': plans ? plans[0].plan_id : '',
				'Subscription Status': status,
			};
		} else {
			return {};
		}
	}

	constructor(incoming: InboxNotificationAPI) {
		this.id = incoming.id;
		this.type = incoming.type;
		const parsedData = JSON.parse(incoming.data);
		this.parameters = parsedData.parameters;
		this.ordwaySubscriptionState = incoming.ordwaySubscriptionState;
		this.reason = parsedData.reason;
		this.createdAt = incoming.created_at;
		this.retryEndpointUrl = parsedData.retryEndpointUrl;
		this.retryEndpointMethod = parsedData.retryEndpointMethod;
		this.product = null;
	}
}
